var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBack = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 18,
  viewBox: "0 0 10 18",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#595959",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M462.403 328.262c.381-.365.98-.346 1.34.041.33.358.34.906.04 1.275l-.081.088L455 338l-8.702-8.334c-.38-.365-.4-.975-.04-1.363.33-.358.867-.4 1.247-.118l.092.077 7.403 7.09 7.403-7.09z",
  transform: "translate(-450 -324) rotate(90 455 333)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBack);
export default ForwardRef;